﻿import * as React from 'react';
import { Container } from 'reactstrap';
import { Header } from "../Header";
import './index.scss';
import { useMsal } from "@azure/msal-react";

export const Layout = (props: any) => {

    const { instance, accounts } = useMsal();

    const request = {
        scopes: ["openid"],
        account: accounts[0]
    };

    instance.acquireTokenSilent(request).then(response => {

        //   console.log(response.idToken);

    }).catch(error => { })


    return (
        <div className="react-container">
            <Header />
            <Container className="pb-container">
                {props.children}
            </Container>
            <Footer />
        </div>
    );
}

const Footer = () => {
    return (
        <div style={{
            bottom: "0",
            position: "fixed",
            textAlign: "center",
            width: "100%",
            backgroundColor: "#010144",
            borderTop: "3px solid #ff623a",
            color: "white",
            padding: "0.5rem"
        }}>
            Porterbrook SIMS &copy;2022
        </div>
    );
}


